module.exports = __webpack_public_path__ + "static/media/password.7f98bc34.svg";